<div class="d-flex justify-content-center align-items-center mb-4 d-lg-none">
  <img alt="" src="assets/images/logo-small.svg" class="kid-logo" />
</div>
<h2 class="text-lg-left text-center text-primary mt-3 mb-4 mt-lg-0 mb-lg-2">Membership Options</h2>
<div class="mb-2 mb-lg-0">Please choose the membership option for each Child listed below:</div>

<ng-container *ngIf="children && membershipOptions">
  <div class="mb-3" *ngFor="let child of children">
    <div class="py-2 m-1">
      <div class="row">
        <div class="col-md-6">
          <label class="mb-0 pt-1">{{ child.Firstname + ' ' + child.Lastname }}</label>
          <p class="mb-0">{{ child.DateOfBirth | date: 'mediumDate':'UTC' }}</p>
        </div>
        <div class="col-md-5 offset-0 offset-md-1">
          <div class="form-group mb-0">
            <select class="form-control bg-muted mt-2 p-1" [(ngModel)]="child.MembershipOptionId">
              <ng-container *ngFor="let membershipOption of membershipOptions">
                <option
                  *ngIf="!(child.IsAlreadyPaid && membershipOption.PaymentType === 0)"
                  [value]="membershipOption.MembershipOptionId"
                >
                  {{ membershipOption.DisplayName }}
                </option>
              </ng-container>
            </select>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="membership-options">
    <div class="card shadow border-0 mb-3 pr-3 m-1" *ngFor="let option of optionInfos">
      <div class="card-body py-2">
        <div class="row align-items-center">
          <div class="col-lg-1 col-2">
            <img alt="" class="membership-image" [src]="option.Image" />
          </div>
          <div class="col-lg-10 col-8">
            <p class="m-0 text-primary">{{ option.DisplayName }}</p>
          </div>
          <div class="col-lg-1 col-2">
            <button
              class="btn btn-primary btn-circle"
              (click)="toggle(option)"
              attr.aria-label="{{ 'registration.item.more.screenreader' | translate }}"
            >
              <span *ngIf="!option.ReadMore" class="icon icon-arrow-1-down font-weight-bold"></span
              ><span *ngIf="option.ReadMore" class="icon icon-arrow-1-up font-weight-bold"></span>
            </button>
          </div>
        </div>
        <div class="membership-description font-size-12 p-2" *ngIf="option.ReadMore" [innerHTML]="option.Description"></div>
      </div>
    </div>
  </div>
</ng-container>
<div class="button-container position-absolute">
  <fgb-registration-navigation (nextButtonClicked)="submitStep()" [stepType]="stepType"></fgb-registration-navigation>
</div>
